import { Link } from 'react-router-dom'
import { FINISHES, FINISH_SWATCHES } from '../data/finishes.js'
import Icon from './Icon.jsx'

// The six finishes as picture cards. Shown both on the finish landing page and at the
// top of the Hardware category, so a customer sees the actual colours without having
// to click through to a separate page first. `headingLevel` keeps the document outline
// right: the cards sit under the h1 on the landing page, under an h2 on the category page.
export default function FinishGrid({ headingLevel: H = 'h2' }) {
  return (
    <div className="finish-grid">
      {FINISHES.map((f) => (
        <Link key={f.slug} to={`/hardware/${f.slug}`} className="finish-card">
          <div className="finish-card-media">
            <img src={f.hero} alt={`${f.heading} shower screen hardware`} loading="lazy" width="1200" height="900" />
          </div>
          <div className="finish-card-body">
            <span className="finish-swatch finish-swatch-lg" style={{ background: FINISH_SWATCHES[f.name] }} aria-hidden="true" />
            <div>
              <H>{f.heading}</H>
              <p>{f.blurb}</p>
            </div>
            <span className="finish-card-go">Shop this finish <Icon name="arrowRight" size={16} /></span>
          </div>
        </Link>
      ))}
    </div>
  )
}
